import React from 'react';
import { View, ViewProps } from 'react-native';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';

import {
  height,
  position,
  width,
  zIndex,
  opacity as opacityStyleUtil,
} from '../../style-utils';

export interface ViewGradiantBackgroundProps extends ViewProps {
  children?: React.ReactNode;
  colorX0?: string;
  colorX1?: string;
  opacity?: number;
}
export const ViewGradiantBackground = ({
  colorX1,
  colorX0,
  children,
  opacity = 1,
  ...props
}: ViewGradiantBackgroundProps) => {
  return (
    <View {...props}>
      <View
        style={[
          height('100%'),
          width('100%'),
          opacityStyleUtil(opacity),
          zIndex(-1),
          position('absolute'),
        ]}
      >
        <Svg height="100%" width="100%">
          <Defs>
            <LinearGradient id="grad" x1="0" y1="0" x2="1" y2="0">
              <Stop offset="0" stopColor={colorX0} stopOpacity="1" />
              <Stop offset="1" stopColor={colorX1} stopOpacity="1" />
            </LinearGradient>
          </Defs>
          <Rect x="0" y="0" width="100%" height="100%" fill="url(#grad)" />
        </Svg>
      </View>
      {children}
    </View>
  );
};
